// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"8eede2b9","260":"a765a59b","354":"b5695361","757":"1ccdec53","779":"a4390590"}[chunkId] + ".chunk.js";
};